import '.an{position:relative;}.ssr-plugin'
import '.jk{width:64px;}.ssr-plugin'
import '.jl{height:64px;}.ssr-plugin'
import '.ai{flex-shrink:0;}.ssr-plugin'
import '.bk{position:absolute;}.ssr-plugin'
import '.jm{bottom:-4px;}.ssr-plugin'
import '.ii{right:-4px;}.ssr-plugin'
import '.fw{border-radius:50%;}.ssr-plugin'
import '.ds{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bb{overflow:hidden;}.ssr-plugin'
import '.jn{width:32px;}.ssr-plugin'
import '.jo{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="an jk jl ai"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bk jm ii fw ds bb jn jo"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
